import _ from "lodash";

export const arraysAreEqual = (arr1 = [], arr2 = []) => {
  if (!arr1 || !arr2 || arr1.length !== arr2.length) {
    return false;
  }

  // Sort the arrays by name
  const sortedArr1 = [...arr1]?.sort((a, b) => a?.name.localeCompare(b?.name));
  const sortedArr2 = [...arr2]?.sort((a, b) => a?.name.localeCompare(b?.name));

  // Compare sorted arrays element by element
  return sortedArr1?.every((item, index) => {
    const item2 = sortedArr2[index];
    return item?.name === item2?.name && item?.id === item2?.id;
  });
};

const byIdentifier = (a, b) =>
  `${a?.identifier ?? ""}${a?.value ?? ""}`.localeCompare(
    `${b?.identifier ?? ""}${b?.value ?? ""}`
  );

export const isArrayEqual = (x, y) => {
  if (x === y) return true;
  if (!Array.isArray(x) || !Array.isArray(y)) return false;
  if (x.length !== y.length) return false;

  const sortedX = [...x].sort(byIdentifier);
  const sortedY = [...y].sort(byIdentifier);

  return _.isEqual(sortedX, sortedY);
};

export const deepClone = (obj) => {
  return structuredClone(obj);
};

export const updateReferralInArray = (array, referralId, updates) => {
  const index = array.findIndex((referral) => referral.id === referralId);
  if (index !== -1) {
    const updatedArray = [...array];
    updatedArray[index] = { ...updatedArray[index], ...updates };
    return updatedArray;
  }
  return array;
};
